import { Col, Row, AutoComplete, Input, Spin } from 'antd';
import axios from 'axios';
import { debounce, get } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import TextField from '../../../../components/Form/Legacy/TextField';

const SEARCH_MUNICIPALITIES_QUERY = `
    query searchAicsMunicipalities($query: String!, $province: String) {
        searchAicsMunicipalities(query: $query, province: $province) {
            id
            name
            province
            cap
        }
    }
`;

class AicsFields extends Component {
    constructor(props) {
        super(props);

        this.state = {
            municipalityOptions: [],
            municipalityLoading: false,
        };

        this.searchMunicipalities = debounce(this.searchMunicipalities.bind(this), 300);
    }

    async searchMunicipalities(query) {
        if (!query || query.length < 2) {
            this.setState({ municipalityOptions: [] });
            return;
        }

        this.setState({ municipalityLoading: true });

        try {
            const response = await axios.post(process.env.REACT_APP_API_EMP, {
                query: SEARCH_MUNICIPALITIES_QUERY,
                variables: { query, province: null },
            });

            const items = get(response, 'data.data.searchAicsMunicipalities', []) || [];

            this.setState({
                municipalityOptions: items.map((m) => ({
                    value: m.name,
                    label: `${m.name} (${m.province})`,
                    province: m.province,
                })),
            });
        } catch (e) {
            this.setState({ municipalityOptions: [] });
        } finally {
            this.setState({ municipalityLoading: false });
        }
    }

    onFiscalCodeChange = (e) => {
        const value = e.target.value || '';
        this.props.onFormChange('fiscal_code', value.toUpperCase().trim());
    };

    onBirthCityChange = (value) => {
        this.props.onFormChange('birth_city', (value || '').toUpperCase());
    };

    onBirthCitySelect = (value, option) => {
        this.props.onFormChange('birth_city', (value || '').toUpperCase());
        if (option && option.province) {
            this.props.onFormChange('birth_province', option.province.toUpperCase());
        }
    };

    onBirthCitySearch = (value) => {
        this.searchMunicipalities(value);
    };

    render() {
        const { form, t } = this.props;
        const { municipalityOptions, municipalityLoading } = this.state;

        return (
            <Row className="gx-mb-4">
                <Col xs={24} className="gx-mb-2">
                    <strong>{t('aics_section_title')}</strong>
                </Col>

                <Col xs={24} className="gx-mb-4">
                    <TextField
                        name="fiscal_code"
                        label={t('fiscal_code') + ' *'}
                        value={form.fiscal_code || ''}
                        onChange={this.onFiscalCodeChange}
                        maxLength={16}
                        validationState={get(form.errors, 'fiscal_code.state', null)}
                        help={get(form.errors, 'fiscal_code.message', null)}
                    />
                </Col>

                <Col xs={24} className="gx-mb-4">
                    <label className="gx-d-block gx-mb-1">{t('birth_city')} *</label>
                    <div style={{ display: 'flex', gap: 8 }}>
                        <div style={{ flex: 1, minWidth: 0 }}>
                            <AutoComplete
                                style={{ width: '100%' }}
                                value={form.birth_city || ''}
                                options={municipalityOptions}
                                onSearch={this.onBirthCitySearch}
                                onSelect={this.onBirthCitySelect}
                                onChange={this.onBirthCityChange}
                                placeholder={t('birth_city_placeholder')}
                                notFoundContent={municipalityLoading ? <Spin size="small" /> : null}
                            />
                        </div>
                        <Input
                            style={{ flex: '0 0 64px', textAlign: 'center', backgroundColor: '#fafafa' }}
                            value={form.birth_province || ''}
                            disabled={true}
                            placeholder="—"
                        />
                    </div>
                    {get(form.errors, 'birth_city.message', null) && (
                        <div className="ant-form-explain gx-text-danger">
                            {get(form.errors, 'birth_city.message')}
                        </div>
                    )}
                </Col>
            </Row>
        );
    }
}

AicsFields.propTypes = {
    form: PropTypes.object.isRequired,
    onFormChange: PropTypes.func.isRequired,
};

export default withTranslation()(AicsFields);
